import { forwardRef, Ref, SVGProps } from 'react'

function _IconWifiOff(props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      ref={ref}
    >
      <g clipPath="url(#clip0_6389_143156)">
        <path
          d="M0.666504 0.666016L15.3332 15.3327"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.1465 7.37305C11.6926 7.63955 12.2032 7.97324 12.6665 8.36638"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.3335 8.36677C4.32155 7.54066 5.51075 6.99091 6.78016 6.77344"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.14014 3.36649C8.56841 3.25141 10.0052 3.42527 11.3648 3.87771C12.7244 4.33014 13.9789 5.05188 15.0535 5.99983"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.946777 6.00008C1.87155 5.18264 2.93191 4.5329 4.08011 4.08008"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.68652 10.7392C6.36332 10.2583 7.17297 10 8.00319 10C8.83341 10 9.64305 10.2583 10.3199 10.7392"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 13.334H8.00667"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6389_143156">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconWifiOff = forwardRef(_IconWifiOff)
